/** Caller supplies only permission-filtered navigation. No route discovery here. */
export function normalizeNavigationQuery(value) {
    return String(value || '').toLocaleLowerCase('ru').replaceAll('ё', 'е').trim().replace(/\s+/g, ' ')
}

const ALIASES = {
    'zoom-meetings': ['зум', 'zoom', 'встречи'],
    'partner-crm': ['партнеры', 'crm', 'база партнеров'],
    inbox: ['входящие', 'задачи'],
    wiki: ['инструкции', 'база знаний'],
    employees: ['сотрудники', 'люди'],
}

export function searchNavigation(items, query, limit = Infinity) {
    const q = normalizeNavigationQuery(query)
    if (!q) return []
    const words = q.split(' ')
    const seen = new Set()
    return items.map(item => {
        const label = normalizeNavigationQuery(item.label)
        const aliases = (ALIASES[item.to] || []).map(normalizeNavigationQuery)
        const text = [label, item.section, item.groupLabel, ...(item.searchLabels || []), ...aliases].map(normalizeNavigationQuery).join(' ')
        const score = label === q || aliases.includes(q) ? 4 : label.startsWith(q) ? 3 : label.includes(q) ? 2 : words.every(word => text.includes(word)) ? 1 : 0
        return { ...item, score }
    }).filter(item => item.score > 0)
        .sort((a, b) => b.score - a.score)
        .filter(item => { if (seen.has(item.to)) return false; seen.add(item.to); return true })
        .slice(0, limit)
}
